// Environment-specific configuration
export const env = {
  NODE_ENV: import.meta.env.MODE || 'development',
  API_URL: import.meta.env.DEV ? '/api' : 'https://api.nightsync.io/api', // Local API proxy in dev, production API in prod
  PUBLIC_API_URL: import.meta.env.DEV ? '/api-proxy' : 'https://api.nightsync.io', // Using a proxy in dev, direct API in prod
  DEBUG: import.meta.env.DEV || false,
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ,
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  MAIN_GCS_URL: import.meta.env.VITE_MAIN_GCS_URL,
}
